import { createSlice } from '@reduxjs/toolkit'
import { AxiosError } from '@src/helpers/httpClient'

import * as ActionTypes from '../constants/actionTypes'
import * as Actions from './actions'
import { defaultState, initialState } from './initialState'

export const SHORT_TERM_COURSE = ActionTypes.GLOBAL_STATE

const stcSlice = createSlice({
  name: SHORT_TERM_COURSE,
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(Actions.stcTopicList.pending, state => {
        state[ActionTypes.STC_TOPIC_LIST].loading = true
      })
      .addCase(Actions.stcTopicList.rejected, (state, action) => {
        state[ActionTypes.STC_TOPIC_LIST].loading = false
        state[ActionTypes.STC_TOPIC_LIST].error = action.payload as AxiosError
      })
      .addCase(Actions.stcTopicList.fulfilled, (state, action) => {
        state[ActionTypes.STC_TOPIC_LIST].loading = false
        state[ActionTypes.STC_TOPIC_LIST].error = null
        state[ActionTypes.STC_TOPIC_LIST].data = action.payload
      })

    builder
      .addCase(Actions.stcTopicAll.pending, state => {
        state[ActionTypes.STC_TOPIC_ALL].loading = true
      })
      .addCase(Actions.stcTopicAll.rejected, (state, action) => {
        state[ActionTypes.STC_TOPIC_ALL].loading = false
        state[ActionTypes.STC_TOPIC_ALL].error = action.payload as AxiosError
      })
      .addCase(Actions.stcTopicAll.fulfilled, (state, action) => {
        state[ActionTypes.STC_TOPIC_ALL].loading = false
        state[ActionTypes.STC_TOPIC_ALL].error = null
        state[ActionTypes.STC_TOPIC_ALL].data = action.payload
      })

    builder
      .addCase(Actions.stcTopic.pending, state => {
        state[ActionTypes.STC_TOPIC].loading = true
      })
      .addCase(Actions.stcTopic.rejected, (state, action) => {
        state[ActionTypes.STC_TOPIC].loading = false
        state[ActionTypes.STC_TOPIC].error = action.payload as AxiosError
      })
      .addCase(Actions.stcTopic.fulfilled, (state, action) => {
        state[ActionTypes.STC_TOPIC].loading = false
        state[ActionTypes.STC_TOPIC].error = null
        state[ActionTypes.STC_TOPIC].data = action.payload
      })

    builder
      .addCase(Actions.stcChapter.pending, state => {
        state[ActionTypes.STC_CHAPTER].loading = true
      })
      .addCase(Actions.stcChapter.rejected, (state, action) => {
        state[ActionTypes.STC_CHAPTER].loading = false
        state[ActionTypes.STC_CHAPTER].error = action.payload as AxiosError
      })
      .addCase(Actions.stcChapter.fulfilled, (state, action) => {
        state[ActionTypes.STC_CHAPTER].loading = false
        state[ActionTypes.STC_CHAPTER].error = null
        state[ActionTypes.STC_CHAPTER].data = action.payload
      })

    builder
      .addCase(Actions.stcChapterAll.pending, state => {
        state[ActionTypes.STC_CHAPTER_ALL].loading = true
      })
      .addCase(Actions.stcChapterAll.rejected, (state, action) => {
        state[ActionTypes.STC_CHAPTER_ALL].loading = false
        state[ActionTypes.STC_CHAPTER_ALL].error = action.payload as AxiosError
      })
      .addCase(Actions.stcChapterAll.fulfilled, (state, action) => {
        state[ActionTypes.STC_CHAPTER_ALL].loading = false
        state[ActionTypes.STC_CHAPTER_ALL].error = null
        state[ActionTypes.STC_CHAPTER_ALL].data = action.payload
      })
    builder.addCase(Actions.stcChapterAllClear, state => {
      state[ActionTypes.STC_CHAPTER_ALL] = defaultState()
    })

    builder
      .addCase(Actions.stcChapterList.pending, state => {
        state[ActionTypes.STC_CHAPTER_LIST].loading = true
      })
      .addCase(Actions.stcChapterList.rejected, (state, action) => {
        state[ActionTypes.STC_CHAPTER_LIST].loading = false
        state[ActionTypes.STC_CHAPTER_LIST].error = action.payload as AxiosError
      })
      .addCase(Actions.stcChapterList.fulfilled, (state, action) => {
        state[ActionTypes.STC_CHAPTER_LIST].loading = false
        state[ActionTypes.STC_CHAPTER_LIST].error = null
        state[ActionTypes.STC_CHAPTER_LIST].data = action.payload
      })

    builder
      .addCase(Actions.stcChapterCreateBatch.rejected, (state, action) => {
        state[ActionTypes.STC_CHAPTER_CREATE_BATCH].loading = false
        state[ActionTypes.STC_CHAPTER_CREATE_BATCH].error = action.payload as AxiosError
      })
      .addCase(Actions.stcChapterCreateBatch.fulfilled, state => {
        state[ActionTypes.STC_CHAPTER_CREATE_BATCH].loading = false
        state[ActionTypes.STC_CHAPTER_CREATE_BATCH].error = null
      })

    builder
      .addCase(Actions.stcChapterCreate.rejected, (state, action) => {
        state[ActionTypes.STC_CHAPTER_CREATE].loading = false
        state[ActionTypes.STC_CHAPTER_CREATE].error = action.payload as AxiosError
      })
      .addCase(Actions.stcChapterCreate.fulfilled, state => {
        state[ActionTypes.STC_CHAPTER_CREATE].loading = false
        state[ActionTypes.STC_CHAPTER_CREATE].error = null
      })

    builder
      .addCase(Actions.stcChapterDelete.rejected, (state, action) => {
        state[ActionTypes.STC_CHAPTER_DELETE].loading = false
        state[ActionTypes.STC_CHAPTER_DELETE].error = action.payload as AxiosError
      })
      .addCase(Actions.stcChapterDelete.fulfilled, state => {
        state[ActionTypes.STC_CHAPTER_DELETE].loading = false
        state[ActionTypes.STC_CHAPTER_DELETE].error = null
      })

    builder
      .addCase(Actions.stcAdmin.pending, state => {
        state[ActionTypes.STC_ADMIN].loading = true
      })
      .addCase(Actions.stcAdmin.rejected, (state, action) => {
        state[ActionTypes.STC_ADMIN].loading = false
        state[ActionTypes.STC_ADMIN].error = action.payload as AxiosError
      })
      .addCase(Actions.stcAdmin.fulfilled, (state, action) => {
        state[ActionTypes.STC_ADMIN].loading = false
        state[ActionTypes.STC_ADMIN].error = null
        state[ActionTypes.STC_ADMIN].data = action.payload
      })

    builder
      .addCase(Actions.stcAction.pending, state => {
        state[ActionTypes.STC].loading = true
      })
      .addCase(Actions.stcAction.rejected, (state, action) => {
        state[ActionTypes.STC].loading = false
        state[ActionTypes.STC].error = action.payload as AxiosError
      })
      .addCase(Actions.stcAction.fulfilled, (state, action) => {
        state[ActionTypes.STC].loading = false
        state[ActionTypes.STC].error = null
        state[ActionTypes.STC].data = action.payload
      })

    builder
      .addCase(Actions.stcAllAction.pending, state => {
        state[ActionTypes.STC_ALL].loading = true
      })
      .addCase(Actions.stcAllAction.rejected, (state, action) => {
        state[ActionTypes.STC_ALL].loading = false
        state[ActionTypes.STC_ALL].error = action.payload as AxiosError
      })
      .addCase(Actions.stcAllAction.fulfilled, (state, action) => {
        state[ActionTypes.STC_ALL].loading = false
        state[ActionTypes.STC_ALL].error = null
        state[ActionTypes.STC_ALL].data = action.payload
      })

    builder
      .addCase(Actions.stcListAction.pending, state => {
        state[ActionTypes.STC_LIST].loading = true
      })
      .addCase(Actions.stcListAction.rejected, (state, action) => {
        state[ActionTypes.STC_LIST].loading = false
        state[ActionTypes.STC_LIST].error = action.payload as AxiosError
      })
      .addCase(Actions.stcListAction.fulfilled, (state, action) => {
        state[ActionTypes.STC_LIST].loading = false
        state[ActionTypes.STC_LIST].error = null
        state[ActionTypes.STC_LIST].data = action.payload
      })

    builder
      .addCase(Actions.stcCategoryAction.pending, state => {
        state[ActionTypes.STC_CATEGORY].loading = true
      })
      .addCase(Actions.stcCategoryAction.rejected, (state, action) => {
        state[ActionTypes.STC_CATEGORY].loading = false
        state[ActionTypes.STC_CATEGORY].error = action.payload as AxiosError
      })
      .addCase(Actions.stcCategoryAction.fulfilled, (state, action) => {
        state[ActionTypes.STC_CATEGORY].loading = false
        state[ActionTypes.STC_CATEGORY].error = null
        state[ActionTypes.STC_CATEGORY].data = action.payload
      })

    builder
      .addCase(Actions.stcCategoryAllAction.pending, state => {
        state[ActionTypes.STC_CATEGORY_ALL].loading = true
      })
      .addCase(Actions.stcCategoryAllAction.rejected, (state, action) => {
        state[ActionTypes.STC_CATEGORY_ALL].loading = false
        state[ActionTypes.STC_CATEGORY_ALL].error = action.payload as AxiosError
      })
      .addCase(Actions.stcCategoryAllAction.fulfilled, (state, action) => {
        state[ActionTypes.STC_CATEGORY_ALL].loading = false
        state[ActionTypes.STC_CATEGORY_ALL].error = null
        state[ActionTypes.STC_CATEGORY_ALL].data = action.payload
      })

    builder
      .addCase(Actions.stcCategoryCreateAction.pending, state => {
        state[ActionTypes.STC_CATEGORY_CREATE].loading = true
      })
      .addCase(Actions.stcCategoryCreateAction.rejected, (state, action) => {
        state[ActionTypes.STC_CATEGORY_CREATE].loading = false
        state[ActionTypes.STC_CATEGORY_CREATE].error = action.payload as AxiosError
      })
      .addCase(Actions.stcCategoryCreateAction.fulfilled, (state, action) => {
        state[ActionTypes.STC_CATEGORY_CREATE].loading = false
        state[ActionTypes.STC_CATEGORY_CREATE].error = null
        state[ActionTypes.STC_CATEGORY_CREATE].data = action.payload
      })

    builder
      .addCase(Actions.stcCategoryDelete.pending, state => {
        state[ActionTypes.STC_CATEGORY_DELETE].loading = true
      })
      .addCase(Actions.stcCategoryDelete.rejected, (state, action) => {
        state[ActionTypes.STC_CATEGORY_DELETE].loading = false
        state[ActionTypes.STC_CATEGORY_DELETE].error = action.payload as AxiosError
      })
      .addCase(Actions.stcCategoryDelete.fulfilled, (state, action) => {
        state[ActionTypes.STC_CATEGORY_DELETE].loading = false
        state[ActionTypes.STC_CATEGORY_DELETE].error = null
        state[ActionTypes.STC_CATEGORY_DELETE].data = action.payload
      })

    builder
      .addCase(Actions.stcCategoryListAction.pending, state => {
        state[ActionTypes.STC_CATEGORY_LIST].loading = true
      })
      .addCase(Actions.stcCategoryListAction.rejected, (state, action) => {
        state[ActionTypes.STC_CATEGORY_LIST].loading = false
        state[ActionTypes.STC_CATEGORY_LIST].error = action.payload as AxiosError
      })
      .addCase(Actions.stcCategoryListAction.fulfilled, (state, action) => {
        state[ActionTypes.STC_CATEGORY_LIST].loading = false
        state[ActionTypes.STC_CATEGORY_LIST].error = null
        state[ActionTypes.STC_CATEGORY_LIST].data = action.payload
      })

    builder
      .addCase(Actions.stcCreateAction.pending, state => {
        state[ActionTypes.STC_CREATE].loading = true
      })
      .addCase(Actions.stcCreateAction.rejected, (state, action) => {
        state[ActionTypes.STC_CREATE].loading = false
        state[ActionTypes.STC_CREATE].error = action.payload as AxiosError
      })
      .addCase(Actions.stcCreateAction.fulfilled, (state, action) => {
        state[ActionTypes.STC_CREATE].loading = false
        state[ActionTypes.STC_CREATE].error = null
        state[ActionTypes.STC_CREATE].data = action.payload
      })

    builder
      .addCase(Actions.stcStepAction.pending, state => {
        state[ActionTypes.STC_STEP].loading = true
      })
      .addCase(Actions.stcStepAction.rejected, (state, action) => {
        state[ActionTypes.STC_STEP].loading = false
        state[ActionTypes.STC_STEP].error = action.payload as AxiosError
      })
      .addCase(Actions.stcStepAction.fulfilled, (state, action) => {
        state[ActionTypes.STC_STEP].loading = false
        state[ActionTypes.STC_STEP].error = null
        state[ActionTypes.STC_STEP].data = action.payload
      })

    builder
      .addCase(Actions.stcStepAdminAll.pending, state => {
        state[ActionTypes.STC_STEP_ADMIN_ALL].loading = true
      })
      .addCase(Actions.stcStepAdminAll.rejected, (state, action) => {
        state[ActionTypes.STC_STEP_ADMIN_ALL].loading = false
        state[ActionTypes.STC_STEP_ADMIN_ALL].error = action.payload as AxiosError
      })
      .addCase(Actions.stcStepAdminAll.fulfilled, (state, action) => {
        state[ActionTypes.STC_STEP_ADMIN_ALL].loading = false
        state[ActionTypes.STC_STEP_ADMIN_ALL].error = null
        state[ActionTypes.STC_STEP_ADMIN_ALL].data = action.payload
      })

    builder
      .addCase(Actions.stcStepAllAction.pending, state => {
        state[ActionTypes.STC_STEP_ALL].loading = true
      })
      .addCase(Actions.stcStepAllAction.rejected, (state, action) => {
        state[ActionTypes.STC_STEP_ALL].loading = false
        state[ActionTypes.STC_STEP_ALL].error = action.payload as AxiosError
      })
      .addCase(Actions.stcStepAllAction.fulfilled, (state, action) => {
        state[ActionTypes.STC_STEP_ALL].loading = false
        state[ActionTypes.STC_STEP_ALL].error = null
        state[ActionTypes.STC_STEP_ALL].data = action.payload
      })

    builder
      .addCase(Actions.stcStepListAction.pending, state => {
        state[ActionTypes.STC_STEP_LIST].loading = true
      })
      .addCase(Actions.stcStepListAction.rejected, (state, action) => {
        state[ActionTypes.STC_STEP_LIST].loading = false
        state[ActionTypes.STC_STEP_LIST].error = action.payload as AxiosError
      })
      .addCase(Actions.stcStepListAction.fulfilled, (state, action) => {
        state[ActionTypes.STC_STEP_LIST].loading = false
        state[ActionTypes.STC_STEP_LIST].error = null
        state[ActionTypes.STC_STEP_LIST].data = action.payload
      })

    builder
      .addCase(Actions.stcStepCompleteAction.pending, state => {
        state[ActionTypes.STC_STEP_COMPLETE].loading = true
      })
      .addCase(Actions.stcStepCompleteAction.rejected, (state, action) => {
        state[ActionTypes.STC_STEP_COMPLETE].loading = false
        state[ActionTypes.STC_STEP_COMPLETE].error = action.payload as AxiosError
      })
      .addCase(Actions.stcStepCompleteAction.fulfilled, (state, action) => {
        state[ActionTypes.STC_STEP_COMPLETE].loading = false
        state[ActionTypes.STC_STEP_COMPLETE].error = null
        state[ActionTypes.STC_STEP_COMPLETE].data = action.payload
      })

    builder
      .addCase(Actions.stcStepCreateAction.pending, state => {
        state[ActionTypes.STC_STEP_CREATE].loading = true
      })
      .addCase(Actions.stcStepCreateAction.rejected, (state, action) => {
        state[ActionTypes.STC_STEP_CREATE].loading = false
        state[ActionTypes.STC_STEP_CREATE].error = action.payload as AxiosError
      })
      .addCase(Actions.stcStepCreateAction.fulfilled, (state, action) => {
        state[ActionTypes.STC_STEP_CREATE].loading = false
        state[ActionTypes.STC_STEP_CREATE].error = null
        state[ActionTypes.STC_STEP_CREATE].data = action.payload
      })

    builder.addCase(Actions.stcStepAdminAllClear, state => {
      state[ActionTypes.STC_STEP_ADMIN_ALL] = defaultState()
    })

    builder.addCase(Actions.stcAllClear, state => {
      state[ActionTypes.STC_ALL] = defaultState()
    })

    builder.addCase(Actions.stcAdminClear, state => {
      state[ActionTypes.STC_ADMIN] = defaultState()
    })
  },
})

export const { reducer: stcReducer } = stcSlice
